import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { RiArrowDownSLine, RiArrowUpSLine } from '@remixicon/react';
import { Link } from 'react-router-dom';

interface SidebarItemProps {
    id: string;
    topLevelLink: string;
    topLevelLabel: string;
    expandable: boolean;
    subItems?: Array<{ label: string; link: string }>;
    defaultExpanded?: boolean;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ id, topLevelLink, topLevelLabel, expandable, subItems = [], defaultExpanded = false }) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    const handleExpandClick = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="menu-item">
            <div className="menu-link-wrapper">
                <Link to={topLevelLink} className="menu-link">{topLevelLabel}</Link>
                {expandable && (
                    <Tooltip title={isExpanded ? "Collapse" : "Expand"} arrow>
                        <IconButton className="menu-item-expand" onClick={handleExpandClick}>
                            {isExpanded ? <RiArrowUpSLine /> : <RiArrowDownSLine />}
                        </IconButton>
                    </Tooltip>
                )}
            </div>
            {expandable && isExpanded && (
                <div className="submenu">
                    {subItems.map((subItem, index) => (
                        <div key={index} className="submenu-item">
                            <Link to={subItem.link} className="submenu-link">{subItem.label}</Link>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SidebarItem;
